export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('warranted');
    if (element) {
        tourCriteriaJson.hotelAvailable = 1;
    }
    return tourCriteriaJson;
};